import React from "react";
import { Button, Modal } from "react-bootstrap";
import image from "../../../Assets/no-img/no-image-icon.png";

const InfoModal = ({ hide, show, listingData, title }) => {
  const {
    brand,
    kit_picture,
    kit_ref_id,
    model_number,
    product_code,
    product_name,
    quantity,
  } = listingData;

  const imageSrc = kit_picture ? kit_picture : image;

  return (
    <Modal className="row_modal" show={show} onHide={hide} centered>
      <Modal.Header className="justify-content-center py-4">
        <Modal.Title className="fw-bold">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex align-items-center border-bottom py-3 gap-3 flex-wrap">
          <h6 className="mb-0">Brand:</h6>
          <span className="d-block text_gray_2 text-capitalize">{brand}</span>
        </div>
        <div className="d-flex mt-2 border-bottom py-3 gap-3 flex-wrap">
          <h6 className="mb-0 pt-3">Kit Picture:</h6>
          <img src={imageSrc} alt="Kit-icon" style={{ maxWidth: "130px" }} />
        </div>
        <div className="d-flex mt-2 align-items-center border-bottom py-3 gap-3 flex-wrap">
          <h6 className="mb-0">Kit Reference ID:</h6>
          <span className="text_gray_2 text-capitalize">{kit_ref_id}</span>
        </div>
        <div className="d-flex mt-2 align-items-center border-bottom py-3 gap-3 flex-wrap">
          <h6 className="mb-0">Model Number:</h6>
          <span className="text_gray_2 text-capitalize">{model_number}</span>
        </div>
        <div className="d-flex mt-2 align-items-center border-bottom py-3 gap-3 flex-wrap">
          <h6 className="mb-0">Product Code:</h6>
          <span className="text_gray_2 text-capitalize">{product_code}</span>
        </div>

        <div className="d-flex mt-2 align-items-center border-bottom py-3 gap-3 flex-wrap">
          <h6 className="mb-0">Product Name:</h6>
          <span className="text_gray_2 text-capitalize">{product_name}</span>
        </div>

        <div className="d-flex mt-2 align-items-center py-3 gap-3 flex-wraps">
          <h6 className="mb-0">Quantity:</h6>
          <span className="text_gray_2 text-capitalize">{quantity}</span>
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button
          variant="secondary"
          className="btn btn-danger px-5"
          onClick={hide}
        >
          Close
        </Button>
        <Button variant="primary" className="d-none" onClick={hide}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InfoModal;
